var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-wrapper",on:{"click":_vm.toggle}},[_c('div',{staticClass:"burger",class:{
      '-active': _vm.active,
      '-not-active': !_vm.active,
      '-init': !_vm.firstClick,
    }},[_c('span',{staticClass:"burger-line -top"}),_c('span',{staticClass:"burger-line -middle"}),_c('span',{staticClass:"burger-line -bottom"})])])}
var staticRenderFns = []

export { render, staticRenderFns }